const MIXPANEL_DEVICE_ID_PREFIX = '$device:'

export function isValidNordyUserId(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    value.trim().length > 0 &&
    !value.startsWith(MIXPANEL_DEVICE_ID_PREFIX)
  )
}
